module.exports = __webpack_public_path__ + "static/media/horoscope-icon-white-7.c25732de.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-white-7.png
// module id = 197
// module chunks = 0